import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as Reports from 'reports/components';
import {
  getDisabledReportPagination,
  getDisabledReportFilters,
  getDisabledReportNeedFetch,
  getDisabledReportIsLoading,
  getDisabledReportVisibleAssets,
} from 'reports/selectors';
import {
  getVisibleAccountsParent,
  getVisibleCostCenters,
  getVisibleEmployees,
  getVisibleStatus,
} from 'selectors/lists';
import { getCompany, getSubcompany } from 'auth/selectors';

import AssetsFormConfig from 'containers/assets/AssetsFormConfig';
import Handlers from 'reports/containers/DisabledReportHandlers';

class DisabledReportContainer extends PureComponent {
  static propTypes = {
    filters: PropTypes.shape({
      fulltext: PropTypes.string.isRequired,
      depreciationType: PropTypes.string.isRequired,
      endDate: PropTypes.string.isRequired,
    }).isRequired,
    pagination: PropTypes.shape({
      page: PropTypes.number.isRequired,
      limit: PropTypes.number.isRequired,
      totalPages: PropTypes.number.isRequired,
      orderBy: PropTypes.string.isRequired,
      order: PropTypes.string.isRequired,
    }).isRequired,
    needFetch: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    assets: PropTypes.array.isRequired,
    company: PropTypes.object.isRequired,
    subcompany: PropTypes.object.isRequired,
  };

  renderRows = () =>
    this.props.assets.map((asset) => (
      <Reports.DisabledReportRow
        key={asset.id}
        asset={asset}
        depreciation={this.props.filters.depreciationType}
      />
    ));

  render = () => (
    <AssetsFormConfig
      render={() => (
        <Handlers
          render={({
            handleExport,
            handleExportPDF,
            handleFiltersChange,
            handleFiltersSubmit,
            handleLimitChange,
            handleOrderChange,
            handlePageChange,
          }) => (
            <Reports.DisabledReportView
              accounts={this.props.accounts}
              costCenters={this.props.costCenters}
              employees={this.props.employees}
              status={this.props.status}
              count={this.props.assets.length}
              filters={this.props.filters}
              handleExport={handleExport}
              handleExportPDF={handleExportPDF}
              handleFiltersChange={handleFiltersChange}
              handleFiltersSubmit={handleFiltersSubmit}
              handleLimitChange={handleLimitChange}
              handleOrderChange={handleOrderChange}
              handlePageChange={handlePageChange}
              isLoading={this.props.isLoading}
              needFetch={this.props.needFetch}
              pagination={this.props.pagination}
              company={this.props.company}
              subcompany={this.props.subcompany}
            >
              {this.renderRows()}
            </Reports.DisabledReportView>
          )}
        />
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  pagination: getDisabledReportPagination(state),
  filters: getDisabledReportFilters(state),
  needFetch: getDisabledReportNeedFetch(state),
  isLoading: getDisabledReportIsLoading(state),
  assets: getDisabledReportVisibleAssets(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
  accounts: getVisibleAccountsParent(state),
  costCenters: getVisibleCostCenters(state),
  employees: getVisibleEmployees(state),
  status: getVisibleStatus(state),
});

export default connect(mapStateToProps, null)(DisabledReportContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/containers/DisabledReportContainer.js